var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "980px" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c("v-icon", [_vm._v("event")]),
              _vm._v(
                " " +
                  _vm._s(
                    _vm.id_duodecima_vacacion != null
                      ? "Editar duodécimas"
                      : "Crear duodécimas"
                  ) +
                  "\n      "
              ),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.adicionarDetalle()
                }
              },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card-text",
                { staticClass: "pt-0" },
                [
                  _c(
                    "v-container",
                    {
                      staticClass: "pt-0",
                      staticStyle: { "min-width": "100%" },
                      attrs: { "grid-list-md": "" }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { shrink: "" } },
                            [
                              _c("p", { staticClass: "formato_green" }, [
                                _vm._v("Seleccionar")
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-radio-group",
                                {
                                  staticClass: "text-field-reducido-border",
                                  attrs: {
                                    row: "",
                                    rules: [
                                      function(v) {
                                        if (v == null) {
                                          return "El campo es obligatorio."
                                        }
                                        return true
                                      }
                                    ]
                                  },
                                  on: {
                                    change: function() {
                                      return (_vm.form = {})
                                    }
                                  },
                                  model: {
                                    value: _vm.id_tipo_duodecima,
                                    callback: function($$v) {
                                      _vm.id_tipo_duodecima = $$v
                                    },
                                    expression: "id_tipo_duodecima"
                                  }
                                },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { shrink: "" } },
                                    [
                                      _c("v-radio", {
                                        attrs: {
                                          label: "Pago de vacaciones",
                                          value: 2
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { shrink: "" } },
                                    [
                                      _c("v-radio", {
                                        attrs: {
                                          label: "Goce de vacaciones",
                                          value: 1
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md6: "", lg6: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  type: "date",
                                  label: "Fecha último día efectivo de trabajo",
                                  outline: "",
                                  success: "",
                                  clearable: ""
                                },
                                on: {
                                  change: function() {
                                    return (_vm.form = {})
                                  }
                                },
                                model: {
                                  value: _vm.fecha_fin_duodecima,
                                  callback: function($$v) {
                                    _vm.fecha_fin_duodecima = $$v
                                  },
                                  expression: "fecha_fin_duodecima"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { shrink: "" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "rgb(134,89,166)",
                                    title: "Calcular duodécima",
                                    dark: ""
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.calcularDatosDuodecima(true)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "material-symbols-outlined"
                                    },
                                    [
                                      _vm._v(
                                        "\n                      calculate\n                      "
                                      )
                                    ]
                                  ),
                                  _vm._v(
                                    "   CALCULAR DUODÉCIMA\n                    "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.switch_tipo_duodecima
                        ? _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "", lg6: "" } },
                                [
                                  _vm.id_tipo_duodecima &&
                                  _vm.fecha_fin_duodecima
                                    ? _c("v-text-field", {
                                        staticClass:
                                          "text-field-reducido-border",
                                        attrs: {
                                          label: "Fecha ingreso",
                                          outline: "",
                                          success: "",
                                          clearable: "",
                                          disabled: ""
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.calculaDiferenciaDias()
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.datos_duodecima
                                              .fecha_incorporacion,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.datos_duodecima,
                                              "fecha_incorporacion",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "datos_duodecima.fecha_incorporacion"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "", lg6: "" } },
                                [
                                  _vm.id_tipo_duodecima &&
                                  _vm.fecha_fin_duodecima
                                    ? _c("v-text-field", {
                                        staticClass:
                                          "text-field-reducido-border",
                                        attrs: {
                                          label:
                                            "Fecha inicio para cálculo de duodécima de vacación",
                                          outline: "",
                                          success: "",
                                          clearable: "",
                                          disabled: ""
                                        },
                                        on: {
                                          input: function($event) {
                                            return _vm.calculaDiferenciaDias()
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.datos_duodecima
                                              .fecha_inicio_calculo,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.datos_duodecima,
                                              "fecha_inicio_calculo",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "datos_duodecima.fecha_inicio_calculo"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "", lg6: "" } },
                                [
                                  _vm.id_tipo_duodecima &&
                                  _vm.fecha_fin_duodecima
                                    ? _c("v-text-field", {
                                        staticClass:
                                          "text-field-reducido-border",
                                        attrs: {
                                          label:
                                            "Días trabajados en la última gestión",
                                          outline: "",
                                          success: "",
                                          clearable: "",
                                          disabled: ""
                                        },
                                        model: {
                                          value:
                                            _vm.datos_duodecima
                                              .dias_trabajados_gestion,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.datos_duodecima,
                                              "dias_trabajados_gestion",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "datos_duodecima.dias_trabajados_gestion"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "", lg6: "" } },
                                [
                                  _vm.id_tipo_duodecima &&
                                  _vm.fecha_fin_duodecima
                                    ? _c("v-text-field", {
                                        staticClass:
                                          "text-field-reducido-border",
                                        attrs: {
                                          label:
                                            "Días de vacación por año según el CAS",
                                          outline: "",
                                          success: "",
                                          clearable: "",
                                          disabled: ""
                                        },
                                        model: {
                                          value:
                                            _vm.datos_duodecima.dias_vacacion,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.datos_duodecima,
                                              "dias_vacacion",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "datos_duodecima.dias_vacacion"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "", lg6: "" } },
                                [
                                  _vm.id_tipo_duodecima &&
                                  _vm.fecha_fin_duodecima
                                    ? _c("v-text-field", {
                                        staticClass:
                                          "text-field-reducido-border",
                                        attrs: {
                                          label:
                                            "Porcentaje de duodécima generada",
                                          outline: "",
                                          success: "",
                                          clearable: "",
                                          disabled: ""
                                        },
                                        model: {
                                          value:
                                            _vm.datos_duodecima
                                              .porcentaje_duodecima,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.datos_duodecima,
                                              "porcentaje_duodecima",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "datos_duodecima.porcentaje_duodecima"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "", lg6: "" } },
                                [
                                  _vm.id_tipo_duodecima &&
                                  _vm.fecha_fin_duodecima
                                    ? _c("v-text-field", {
                                        staticClass:
                                          "text-field-reducido-border",
                                        attrs: {
                                          label: "Saldo de vacación a la fecha",
                                          outline: "",
                                          success: "",
                                          clearable: "",
                                          disabled: ""
                                        },
                                        model: {
                                          value: _vm.datos_duodecima.dias_saldo,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.datos_duodecima,
                                              "dias_saldo",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "datos_duodecima.dias_saldo"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "", lg6: "" } },
                                [
                                  _vm.id_tipo_duodecima &&
                                  _vm.fecha_fin_duodecima
                                    ? _c("v-text-field", {
                                        staticClass:
                                          "text-field-reducido-border",
                                        attrs: {
                                          label:
                                            "Días de duodécima de vacación generada al último día efectivo de trabajo",
                                          outline: "",
                                          success: "",
                                          clearable: "",
                                          disabled: ""
                                        },
                                        model: {
                                          value:
                                            _vm.datos_duodecima.dias_duodecima,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.datos_duodecima,
                                              "dias_duodecima",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "datos_duodecima.dias_duodecima"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "", lg6: "" } },
                                [
                                  _vm.id_tipo_duodecima &&
                                  _vm.fecha_fin_duodecima
                                    ? _c("v-text-field", {
                                        staticClass:
                                          "text-field-reducido-border",
                                        attrs: {
                                          label: "Consolidado de vacaciones",
                                          outline: "",
                                          success: "",
                                          clearable: "",
                                          disabled: ""
                                        },
                                        model: {
                                          value:
                                            _vm.datos_duodecima
                                              .dias_consolidados,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.datos_duodecima,
                                              "dias_consolidados",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "datos_duodecima.dias_consolidados"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "", lg6: "" } },
                                [
                                  _vm.id_tipo_duodecima &&
                                  _vm.fecha_fin_duodecima
                                    ? _c("v-text-field", {
                                        staticClass:
                                          "text-field-reducido-border",
                                        attrs: {
                                          label:
                                            "Consolidado de vacaciones final",
                                          outline: "",
                                          success: "",
                                          clearable: "",
                                          disabled: ""
                                        },
                                        model: {
                                          value:
                                            _vm.datos_duodecima
                                              .dias_consolidados_total,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.datos_duodecima,
                                              "dias_consolidados_total",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "datos_duodecima.dias_consolidados_total"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.switch_tipo_duodecima &&
                      _vm.id_tipo_duodecima &&
                      _vm.id_tipo_duodecima == 1 &&
                      _vm.fecha_fin_duodecima
                        ? _c("v-layout", { attrs: { row: "", wrap: "" } }, [
                            _c("p", { staticClass: "titulo" }, [
                              _vm._v("Detalle de saldos")
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.switch_tipo_duodecima &&
                      _vm.id_tipo_duodecima &&
                      _vm.id_tipo_duodecima == 1 &&
                      _vm.fecha_fin_duodecima
                        ? _c("v-layout", { attrs: { row: "", wrap: "" } }, [
                            _c(
                              "ul",
                              [
                                _vm._l(_vm.detalle_gestiones_vacacion, function(
                                  detalle_gestiones,
                                  index
                                ) {
                                  return _c(
                                    "li",
                                    { key: index },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "rgb(26,122,230)" } },
                                        [_vm._v(_vm._s("folder"))]
                                      ),
                                      _vm._v(" "),
                                      _c("b", [
                                        _vm._v(
                                          " Saldo de vacación periodo " +
                                            _vm._s(
                                              parseInt(
                                                detalle_gestiones.periodo
                                              ) - 1
                                            ) +
                                            " -  " +
                                            _vm._s(detalle_gestiones.periodo) +
                                            " : "
                                        )
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(detalle_gestiones.saldo) +
                                          "\n                "
                                      )
                                    ],
                                    1
                                  )
                                }),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { color: "rgb(26,122,230)" } },
                                      [_vm._v(_vm._s("folder"))]
                                    ),
                                    _vm._v(" "),
                                    _c("b", [
                                      _vm._v(
                                        "Saldo de vacación ganada (duodécimas) al   " +
                                          _vm._s(_vm.fecha_fin_duodecima) +
                                          " : "
                                      )
                                    ]),
                                    _vm._v(
                                      _vm._s(_vm.datos_duodecima.dias_duodecima)
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { color: "rgb(26,122,230)" } },
                                      [_vm._v(_vm._s("folder"))]
                                    ),
                                    _vm._v(" "),
                                    _c("b", [
                                      _vm._v("Total días de vacación : ")
                                    ]),
                                    _vm._v(
                                      _vm._s(
                                        _vm.datos_duodecima
                                          .dias_consolidados_total
                                      ) + "\n                "
                                    )
                                  ],
                                  1
                                )
                              ],
                              2
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.switch_tipo_duodecima &&
                      _vm.id_tipo_duodecima &&
                      _vm.id_tipo_duodecima == 2 &&
                      _vm.fecha_fin_duodecima
                        ? _c("v-layout", { attrs: { row: "", wrap: "" } }, [
                            _c(
                              "ul",
                              [
                                _vm._l(_vm.detalle_gestiones_vacacion, function(
                                  detalle_gestiones,
                                  index
                                ) {
                                  return _c(
                                    "li",
                                    { key: index },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            color: detalle_gestiones.valida
                                              ? "rgb(26,122,230)"
                                              : "rgb(179,77,77)"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              detalle_gestiones.valida
                                                ? "check_circle"
                                                : "close"
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("b", [
                                        _vm._v(
                                          " Saldo de vacación periodo " +
                                            _vm._s(
                                              parseInt(
                                                detalle_gestiones.periodo
                                              ) - 1
                                            ) +
                                            " -  " +
                                            _vm._s(detalle_gestiones.periodo) +
                                            " : "
                                        )
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(detalle_gestiones.saldo) +
                                          "\n                "
                                      )
                                    ],
                                    1
                                  )
                                }),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          color: _vm.datos_duodecima
                                            .duodecima_valida
                                            ? "rgb(26,122,230)"
                                            : "rgb(179,77,77)"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.datos_duodecima.duodecima_valida
                                              ? "check_circle"
                                              : "close"
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("b", [
                                      _vm._v(
                                        "Saldo de vacación ganada (duodécimas) al   " +
                                          _vm._s(_vm.fecha_fin_duodecima) +
                                          " : "
                                      )
                                    ]),
                                    _vm._v(
                                      _vm._s(_vm.datos_duodecima.dias_duodecima)
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "li",
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { color: "rgb(26,122,230)" } },
                                      [_vm._v(_vm._s("folder"))]
                                    ),
                                    _vm._v(" "),
                                    _c("b", [
                                      _vm._v("Total días de vacación : ")
                                    ]),
                                    _vm._v(
                                      _vm._s(
                                        _vm.datos_duodecima
                                          .dias_consolidados_total
                                      ) + "\n                "
                                    )
                                  ],
                                  1
                                )
                              ],
                              2
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _vm.switch_tipo_duodecima &&
                      _vm.id_tipo_duodecima &&
                      _vm.id_tipo_duodecima == 1 &&
                      _vm.fecha_fin_duodecima
                        ? _c("v-layout", { attrs: { row: "", wrap: "" } }, [
                            _c("p", { staticClass: "titulo" }, [
                              _vm._v("Registrar duodécimas adquiridas:")
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.switch_tipo_duodecima &&
                      _vm.id_tipo_duodecima &&
                      _vm.id_tipo_duodecima == 1 &&
                      _vm.fecha_fin_duodecima
                        ? _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "", lg4: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      type: "date",
                                      label: "Fecha desde",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      success: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.calculaDiferenciaDias()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.fecha_desde,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "fecha_desde", $$v)
                                      },
                                      expression: "form.fecha_desde"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "", lg4: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      type: "date",
                                      label: "Fecha hasta",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      outline: "",
                                      success: "",
                                      clearable: ""
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.calculaDiferenciaDias()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.fecha_hasta,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "fecha_hasta", $$v)
                                      },
                                      expression: "form.fecha_hasta"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", md6: "", lg4: "" } },
                                [
                                  _vm.form.fecha_desde && _vm.form.fecha_hasta
                                    ? _c("v-text-field", {
                                        attrs: {
                                          label: "Días",
                                          disabled: "",
                                          outline: "",
                                          success: "",
                                          clearable: ""
                                        },
                                        model: {
                                          value: _vm.total_dias,
                                          callback: function($$v) {
                                            _vm.total_dias = $$v
                                          },
                                          expression: "total_dias"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.switch_tipo_duodecima &&
                      _vm.id_tipo_duodecima &&
                      _vm.id_tipo_duodecima == 1 &&
                      _vm.fecha_fin_duodecima
                        ? _c(
                            "v-layout",
                            [
                              _c(
                                "v-flex",
                                [
                                  _c(
                                    "v-radio-group",
                                    {
                                      attrs: {
                                        row: "",
                                        rules: [
                                          function(v) {
                                            if (v == null) {
                                              return "El campo es obligatorio."
                                            }
                                            return true
                                          }
                                        ]
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.calculaDiferenciaDias()
                                        }
                                      },
                                      model: {
                                        value: _vm.form.radio_data,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "radio_data", $$v)
                                        },
                                        expression: "form.radio_data"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { xs4: "" } },
                                        [
                                          _c("v-radio", {
                                            attrs: {
                                              label: "Todo el día",
                                              value: 0
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs4: "" } },
                                        [
                                          _c("v-radio", {
                                            attrs: {
                                              label: "Solo mañana",
                                              value: 1
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs4: "" } },
                                        [
                                          _c("v-radio", {
                                            attrs: {
                                              label: "Solo tarde",
                                              value: 2
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.switch_tipo_duodecima &&
                      _vm.id_tipo_duodecima &&
                      _vm.id_tipo_duodecima == 1 &&
                      _vm.fecha_fin_duodecima
                        ? _c(
                            "v-layout",
                            [
                              _c(
                                "v-flex",
                                { attrs: { md6: "" } },
                                [
                                  _c("v-spacer"),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "success",
                                        block: "",
                                        type: "submit",
                                        disabled: !_vm.valid
                                      }
                                    },
                                    [
                                      _c("v-icon", [_vm._v("arrow_downward")]),
                                      _vm._v(
                                        "\n                Registrar\n              "
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            [
                              _c("v-data-table", {
                                staticClass: "elevation-1",
                                attrs: {
                                  items: _vm.permiso_detalles,
                                  "hide-actions": "",
                                  headers: _vm.headers
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "items",
                                    fn: function(props) {
                                      return [
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm
                                                    .$moment(
                                                      props.item.fecha_desde
                                                    )
                                                    .format("DD/MM/YYYY")
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm
                                                    .$moment(
                                                      props.item.fecha_hasta
                                                    )
                                                    .format("DD/MM/YYYY")
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm
                                                    .$moment(
                                                      props.item.hora_desde,
                                                      "HH:mm"
                                                    )
                                                    .format("HH:mm")
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm
                                                    .$moment(
                                                      props.item.hora_hasta,
                                                      "HH:mm"
                                                    )
                                                    .format("HH:mm")
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  props.item.dias_vacacion
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  color: "error",
                                                  icon: "",
                                                  title: "Eliminar"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.eliminarDetalle(
                                                      props.item.id
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-icon", [_vm._v("delete")])
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _vm.switch_tipo_duodecima &&
                              _vm.id_tipo_duodecima &&
                              _vm.id_tipo_duodecima == 1 &&
                              _vm.fecha_fin_duodecima
                                ? _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c("p", { staticClass: "titulo" }, [
                                        _vm._v(
                                          "Total días programados: " +
                                            _vm._s(_vm.total_dias_solicitadas)
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                { staticClass: "pr-4" },
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("save")]),
                      _vm._v("\n          Guardar\n        ")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "error" },
                      on: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("cancel")]),
                      _vm._v(
                        " " + _vm._s(_vm.$t("common.cancel")) + "\n        "
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-776cf804", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-776cf804","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/vacacion_rrhh/dialogs/CrearDuodecima.vue
// module id = null
// module chunks = 